<template>
    <div>
        {{ invoice.invoiceid }}
        <input type="checkbox" v-model="isSelected" >
    </div>
</template>

<script>
import cInvoiceReceiveRow from '@/components/invoice/cInvoiceReceiveRow'
const numeral = require('numeral');

export default {
    props: {
        invoice : Object ,checkAll : Boolean
    },
    data: () => ({
        isSelected : false,
        invoiceId : ''
    }),  
    methods: {
        onChangeSelected: function (invoiceChanged){
            // this.$emit('setInvoiceChanged', invoiceChanged)
        }                
    },    
    watch: {
        checkAll: function (newObj) {
            console.log('checkAll change');
            this.isSelected = newObj 
        }
    },    
    created() {
        this.invoiceId = this.invoice.invoiceid
    }      
}

</script>
<style>
</style>


// WEBPACK FOOTER //
// cKontraCreateRow.vue?d2a1e03c